<template>
  <component :is="dynamicNavigationSection" to="/signworkflows/inbox" @click.native="getAllSignworkflowsStatusCounts">
    <template #header>
      <EuiIcon size="medium" name="sign"/>
      {{ $t('signworkflows.aside-menu.title') }}
    </template>
    <EuiListSubheader>{{ $t('signworkflows.aside-menu.label.yourSignbooks') }}</EuiListSubheader>
    <EuiNavigationItem v-if="deskRhFeatures.includes('ParaphCreateUpdate')" disc :to="{ name: 'paraphers.create.addParameters' }">{{ $t('signworkflows.create-signworkflow') }}</EuiNavigationItem>
    <EuiNavigationItem disc to="/signworkflows/inbox">{{ $t('signworkflows.tab.inbox') }}
      <template #meta>
        <EuiBadge color="primary" inverted :content="parseInt(signworkflowsStatus['inbox'])" :max="99"/>
      </template>
    </EuiNavigationItem>
    <EuiNavigationItem disc to="/signworkflows/sent">{{ $t('signworkflows.tab.sent') }}
      <template #meta>
        <EuiBadge color="primary" inverted :content="parseInt(signworkflowsStatus['sent'])" :max="99"/>
      </template>
    </EuiNavigationItem>
    <template>
      <EuiListSubheader>{{ $t('signworkflows.aside-menu.label.allSignbooks') }}</EuiListSubheader>
      <EuiNavigationItem disc to="/signworkflows/waiting-for-action">
        {{ $t('signworkflows.status.to-validate') }}
        <template #meta>
          <EuiBadge color="primary" inverted :content="parseInt(signworkflowsStatus['waiting-for-action'])" :max="99"/>
        </template>
      </EuiNavigationItem>
      <EuiNavigationItem disc to="/signworkflows/waiting-for-others">
        {{ $t('signworkflows.status.waiting-for-others') }}
        <template #meta>
          <EuiBadge color="primary" inverted :content="parseInt(signworkflowsStatus['waiting-for-others'])" :max="99"/>
        </template>
      </EuiNavigationItem>
      <EuiNavigationItem disc to="/signworkflows/expire-soon">
        {{ $t('signworkflows.status.expire-soon') }}
        <template #meta>
          <EuiBadge color="primary" inverted :content="parseInt(signworkflowsStatus['expire-soon'])" :max="99"/>
        </template>
      </EuiNavigationItem>
      <EuiNavigationItem disc to="/signworkflows/expired">
        {{ $t('signworkflows.status.expired') }}
        <template #meta>
          <EuiBadge color="primary" inverted :content="parseInt(signworkflowsStatus['expired'])" :max="99"/>
        </template>
      </EuiNavigationItem>
      <EuiNavigationItem disc to="/signworkflows/completed">
        {{ $t('signworkflows.status.completed') }}
        <template #meta>
          <EuiBadge color="primary" inverted :content="parseInt(signworkflowsStatus['completed'])" :max="99"/>
        </template>
      </EuiNavigationItem>
      <EuiNavigationItem disc to="/signworkflows/archived">
        {{ $t('signworkflows.tab.archive') }}
        <template #meta>
          <EuiBadge color="primary" inverted :content="parseInt(signworkflowsStatus['archived'])" :max="99"/>
        </template>
      </EuiNavigationItem>
    </template>
  </component>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
  name: 'App',
  props: {
    isMiniVariant: Boolean,
    isSidenavOpen: Boolean,
  },
  data() {
    return {
      status: [
        'inbox',
        'sent',
        'waiting-for-action',
        'waiting-for-others',
        'expire-soon',
        'expired',
        'completed',
        'archived',
      ],
      searchParams: {
        offset: 0,
        limit: 1,
      },
    };
  },
  computed: {
    ...mapState({
      signworkflowsStatus: state => state.ModuleEdocSign.parapheurs.status,
    }),
    ...mapGetters({
      user: 'ModuleEdocSign/auth/user',
    }),
    dynamicNavigation() {
      if (this.isMiniVariant) {
        return 'EuiNavigationMini';
      }
      return 'EuiNavigation';
    },
    dynamicNavigationSection() {
      if (this.isMiniVariant) {
        return 'EuiNavigationSectionMini';
      }
      return 'EuiNavigationSection';
    },
    deskRhFeatures() {
      return JSON.parse(localStorage.getItem('deskRhFeatures'));
    },
  },
  methods: {
    ...mapActions({
      storeGetSignworkflows: 'ModuleEdocSign/parapheurs/getSignworkflows',
    }),
    getAllSignworkflowsStatusCounts() {
      if (this.user !== undefined) {
        return Promise.all(this.status
          .map(status => this.storeGetSignworkflows({
            ...this.searchParams,
            params: [{
              paramName: 'status',
              paramValue: status,
            }],
          })));
      }
    },
  },
};
</script>

<style scoped>
  .eui-o-navigation {
    height: 0;
  }
</style>
